import {
  Box,
  FILTER_CONTROLLER_EVENTS,
  FiltersController,
  Icon,
  Text,
  propsHooks,
  useSyncFilterValue,
} from '@centra/centra-ui'
import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import { updatePinnedFilters } from './utils'

import styled from './SingleModalFilter.module.scss'
import { FILTER_COMPONENT_TYPE } from '../../consts'
import { TPlatformFiltersType } from '../../models'

interface ISingleModalFilterProps {
  filterLabel: string
  controller: FiltersController
  filterName: string
  query: string
  setNewPinnedFilters: Dispatch<SetStateAction<string | null>>
  pinnedFilters: string | null
}

export const SingleModalFilter: FC<ISingleModalFilterProps> = ({
  filterLabel,
  controller,
  filterName,
  query,
  setNewPinnedFilters,
  pinnedFilters,
}) => {
  const { hoveredCallbacks, isHovered } = propsHooks.useHovered()
  const predicate = useSyncFilterValue({
    controller,
  })

  const [isPinned, setIsPinned] = useState(false)
  const scheme = useSyncFilterValue({ controller, event: FILTER_CONTROLLER_EVENTS.SCHEME })
  const activeFilter = scheme.get(filterName)

  const Component = FILTER_COMPONENT_TYPE[activeFilter?.type as TPlatformFiltersType]

  useEffect(() => {
    if (pinnedFilters) {
      try {
        const pinnedFiltersArr = JSON.parse(pinnedFilters)
        if (pinnedFiltersArr.includes(filterName)) {
          setIsPinned(true)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }, [])

  const handlePinFilter = () => {
    updatePinnedFilters(pinnedFilters, filterName, setNewPinnedFilters, setIsPinned)
  }

  return (
    <Box fullWidth alignItems={'center'} {...hoveredCallbacks}>
      <Box style={{ width: '156px' }}>
        <Text id="filterLabelText" weight="bold">
          {filterLabel}
        </Text>
      </Box>
      <Box marginRight={32} className={styled.iconContainer}>
        {(isHovered || isPinned) && (
          <Icon
            id={`pinIcon${filterName}`}
            view={isPinned ? 'basicBlack' : 'basicGreySemiDark'}
            name="pin"
            onClick={handlePinFilter}
          />
        )}
      </Box>
      <Box style={{ width: '384px' }}>
        <Component controller={controller} filterName={filterName} predicate={predicate} query={query} />
      </Box>
    </Box>
  )
}
